import {type FC, memo} from "react";

import FeeListItem from "./FeeListItem";
import type {Fee} from "./types";

import {Table, TableHeader, TableRow} from "@/client/components/Table";

interface Props {
    fees: Fee[];
    currency: string;
    onEdit: (tax: Fee) => void;
    onRemove: (idx: number) => void;
}

const FeeList: FC<Props> = ({fees, currency, onEdit, onRemove}) => {
    return (
        <Table size="sm">
            <TableRow>
                <TableHeader>Name</TableHeader>
                <TableHeader>Type</TableHeader>
                <TableHeader>Entity Type</TableHeader>
                <TableHeader>Tax Type</TableHeader>
                <TableHeader>Unit</TableHeader>
                <TableHeader>Amount</TableHeader>
                <TableHeader align="end">Action</TableHeader>
            </TableRow>
            {fees.map((fee, idx) => (
                <FeeListItem
                    key={fee.name}
                    currency={currency ?? ""}
                    fee={fee}
                    idx={idx}
                    onEdit={onEdit}
                    onRemove={onRemove}
                />
            ))}
        </Table>
    );
};

export default memo(FeeList);
